<template>
    <div>
      <iframe :src="iframeSrc" width="100%" height="600px" scrolling="no"></iframe>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      url: {
        type: String,
        required: true
      }
    },
    computed: {
      iframeSrc() {
        return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.url)}`;
      }
    }
  }
  </script>
  